export default () => {
    const {accId, versionId, version} = window.__baseInfo;
    const currentVersion = version.find(v => v.versionId === versionId);

    return currentVersion;
}